import { render } from "./MaterialInput.vue?vue&type=template&id=b61bc9d6&scoped=true"
import script from "./MaterialInput.vue?vue&type=script&lang=js"
export * from "./MaterialInput.vue?vue&type=script&lang=js"

import "./MaterialInput.vue?vue&type=style&index=0&id=b61bc9d6&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.member/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b61bc9d6"]])

export default __exports__